import { render, staticRenderFns } from "./copy-button.vue?vue&type=template&id=27b8f1dc&scoped=true&"
import script from "./copy-button.vue?vue&type=script&lang=ts&"
export * from "./copy-button.vue?vue&type=script&lang=ts&"
import style0 from "./copy-button.vue?vue&type=style&index=0&id=27b8f1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8f1dc",
  null
  
)

export default component.exports